module.exports = __webpack_public_path__ + "img/1693448947325-bc484310-9093-4648-9f09-33fcd3b062f5.jpeg.69e92f18.webp";